import * as React from "react";
import * as classNames from "classnames";
import { Form, Errors, LocalForm, Control, actions, Field } from 'react-redux-form';
import TextFormGroup from "../Controls/TextFormGroup";
import TextAreaFormGroup from "../Controls/TextAreaFormGroup";
import ValidationMessage from "../Controls/ValidationMessage";
import { required, maxLength, minLength,numberRange, url} from "../Validators/";
import update from "immutability-helper";
import {
  updateOn,
  validateOn,
  mapProps,
  showErrors
} from "../Controls/ReactReduxFormSettings";

export interface TextProps {}

const style = { zIndex: 99,
                backgroundColor: '#aaaaaa',
                width: '100%',
                color: 'white',
                paddingLeft: '10px'};

class TextTagging extends React.PureComponent<any, any> {
  
  inputRef;
  constructor(props) {
    super(props);

    this.state = { showTags: false, tagFilter: undefined, value: undefined, selectedTags: [] };
    this.onTextChange = this.onTextChange.bind(this);
    this.onTagSelected = this.onTagSelected.bind(this);
    
  }

  componentDidUpdate(prevProps, prevState){
      if(this.props.selectedTags == undefined && prevProps.selectedTags != undefined)
      {
        this.setState({ selectedTags: [] });
      }
  }

  onTagSelected(tag, event){
      
      var codedTag = ` (@${tag.name})`;
      let value = this.state.value;
      var searchString = "@";//value.length <= 2 ? "@" : " @";
      var index = value.lastIndexOf(searchString); 
      var endTagIndex = value.substring(index+searchString.length, value.length).indexOf(" ");
      endTagIndex = endTagIndex < 0 ? value.length : endTagIndex;
      var tagLetters = value.substring(index, endTagIndex);
      value = value.replace(tagLetters, codedTag);

      var newItems = this.state.selectedTags;
        newItems = update(this.state.selectedTags, { $push: [tag] });

      this.setState({showTags: false, tagFilter: undefined, selectedTags: newItems});

      this.props.onChange(value, newItems);
  }

  onTextChange(event){
    var value = event.target.value;
    var searchString = "@";//value.length <= 2 ? "@" : " @";
    var index = value.lastIndexOf(searchString); 
    var tagLetters = index >= 0 && index < value.length-1 ? value.substring(index+searchString.length, value.length) : undefined;
    tagLetters = tagLetters !== undefined && tagLetters.lastIndexOf(" ") < 0 ? tagLetters : undefined;
    
    // Check if there is a space since the @ - do not show tags if there is
    let showTags = index >= 0 && (tagLetters != undefined && tagLetters.lastIndexOf(" ") < 0) ? true : false;
    this.setState({showTags: showTags, tagFilter: tagLetters, value: value});
  }

  render() {
    let tags = this.props.tags;
    if(this.state.tagFilter != undefined && this.state.tagFilter !== ""){
      
      tags = tags.filter(t =>  t.name.toLowerCase().startsWith(this.state.tagFilter.toLowerCase()) // Check for first name
                                || t.name.toLowerCase().indexOf(` ${this.state.tagFilter.toLowerCase()}`) > 0 ) // Check for last name
    }
    
    let showTags = this.state.showTags ? <div style={{
      position: 'absolute', 
      zIndex: 99,
      backgroundColor: 'white',
      width: '100%',
      paddingLeft: '10px',
      border: "solid 1px #aaaaaa",
      marginRight: "-10px"}}>
      {tags.map((t, i) => {
        let avatarImg = t.forumAttachmentId ? 
                          `/api/attachment/${t.forumAttachmentId}` : 
                          require("../../assets/img/Unconfirmed.png");
                          
        return <div key={i} className="row vertical-align" style={{cursor: "pointer"}} onClick={this.onTagSelected.bind(this, t)}>
            <div className="col-12">
              <div className="py-2" style={{borderBottom: "solid 1px #cccccc"}}>
                <div className="circle-avatar" style={{display: "inline-block", width: "30px", height: "30px", float: "left"}}>
                    <img src={avatarImg}/>
                </div>
                <div className="px-2" style={{display: "inline-block"}}>
                  {t.name}
                </div>
              </div>
            </div>
        </div>
      })}</div> : undefined;

    
    let textField = this.props.rows ? <Control.textarea
                        ref={(input) => { this.inputRef = input }}
                        model={this.props.model}
                        id={this.props.id}
                        component={TextAreaFormGroup}
                        rows={this.props.rows}
                        placeholder={this.props.placeholder}
                        maxLength={this.props.maxLength}
                        onChange={this.onTextChange}
                        autoFocus={this.props.autoFocus}
                        validators={{
                            required: required,
                            maxLength: maxLength.bind(null, 8000)
                        }}
                        updateOn={updateOn}
                        validateOn={validateOn}
                        mapProps={mapProps}
                        controlProps={{
                            validate: true
                        }}
                        >
                        <Errors
                            model=".comment"
                            messages={{
                                maxLength: "Post is too long",
                                required: "Post is required"
                            }}
                            show={showErrors}
                            component={ValidationMessage}
                        />
                        </Control.textarea> : 
                        <Control.text
                            ref={(input) => { this.inputRef = input }}
                            model={this.props.model}
                            id={this.props.id}
                            className="form-control-sm lightgrey-bg"
                            placeholder={this.props.placeholder}
                            maxLength={this.props.maxLength}
                            style={{width: "100%"}}
                            autoFocus={this.props.autoFocus}
                            onChange={this.onTextChange}
                            >
                            </Control.text>;
    return (
      <div style={{width:'100%'}}>
          {textField}
          {showTags}
      </div>
    );
  }
}

export default TextTagging;




// WEBPACK FOOTER //
// ./src/components/Controls/TextTagging.tsx